import { Container } from "components";

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "services/api";

export const SecurityTerms = () => {
  const [fetchdetails, setFetchDetails] = useState({});
  const fetchData = async () => {
    try {
      const response = await api.get("/site-settings");
      const details = response?.data?.data?.siteSettings;
      setFetchDetails(details);
      console.log("response:", details);
    } catch (error) {
      console.log("error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <Container>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <nav aria-label="breadcrumb" className="ms-4">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="#">Security</Link>
              </li>
              <li class="breadcrumb-item active">Terms and conditions</li>
            </ol>
          </nav>
          <div className="card mb-4 mx-4">
            <h5 className="card-header">Terms and conditions</h5>
            <div className="card-body">
              <p
                className="title-slogan "
                dangerouslySetInnerHTML={{
                  __html: fetchdetails?.terms_conditions,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {/* <div className="home-page">
        
      </div> */}
    </Container>
  );
};
